<template>
   <div class="Home">
      <div class="Home-one" :height="banberHeight + 'px'" id="a1">
        <el-carousel class="Home-one-banber" :indicator-position="banners.length<=1&&'none'" :arrow="banners.length>1?'hover':'never'" :width="banberWidth+'px'" :height="banberHeight + 'px'">
          <el-carousel-item v-for="banner in banners" :key="banner">
            <el-image :src="banner"></el-image>
          </el-carousel-item>
        </el-carousel>
      </div>
      <el-card class="Home-two-bg" shadow="always" :body-style="{ padding: '0px' }">
        <el-row :gutter="50">
          <el-col class="Home-two-item" :span="4" v-for="(intro, index) in intros" :key="index">
            <img class="Home-two-item-icon" :src="intro.Icon">
            <div class="Home-two-item-title"> {{intro.Title}} </div>
            <div class="Home-two-item-subheading"> {{intro.Subheading}} </div>
          </el-col>
        </el-row>
      </el-card>
      <div class="Home-huoke" id="a2">
        <div class="Home-huoke-title"> 店铺获客，用宝来客 </div>
        <div class="Home-huoke-subheading"> 企业微信+公众号+小程序 私域流量营销全渠道 </div>
        <el-row class="Home-huoke-item-bg">
          <el-col :span="6" v-for="(huoke, index) in HuoKes" :key="index">
            <div class="Home-huoke-item-bg-item">
              <img class="Home-huoke-item-bg-item-title-bg" :src="require(`../assets/img/home/huoke_title_bg${index+1}.png`)">
              <div class="Home-huoke-item-bg-item-title"> {{huoke.Title}} </div>
              <el-row>
                <el-col :span="12" v-for="(item, index) in huoke.Icons" :key="index + item.Title">
                  <img class="Home-huoke-item-bg-item-icon" :src="item.Icon">
                  <div class="Home-huoke-item-bg-item-title1"> {{item.Title}} </div>
                </el-col>
              </el-row>
              <div class="Home-huoke-item-bg-item-bottom">
                <el-button class="Home-huoke-item-bg-item-bottom-button" @click="onHuoKeDetails(huoke.Id)" round>进一步了解</el-button>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <HomeProduct></HomeProduct>
      <HomeProject></HomeProject>
      <HomeCase></HomeCase>
      <div class="Home-advertising" id="a6">
        <div class="Home-advertising-bg">
          <div class="Home-advertising-bg-title"> 做好私域，不只是需要工具，更需要运营技能 </div>
          <div class="Home-advertising-bg-subheading"> 震旦学院，一站式培训体系，帮你建立强大的私域运营团队！ </div>
          <div class="Home-advertising-bg-content">
            <div class="Home-advertising-bg-left">
              <div class="Home-advertising-bg-left-title"> 每周三 晚8:00【震旦学院直播】 </div>
              <div class="Home-advertising-bg-left-subheading"> 震旦学院直播间与你分享更多行业干货、运营技巧、行业趋势 </div>
              <el-button class="Home-advertising-bg-left-button" @click="onBaoLaiKem" plain> 了解详情 </el-button>
            </div>
            <img class="Home-advertising-bg-right" :src=img.Teams>
          </div>
        </div>
      </div>
      <div class="Home-bottom" id="a7">
        <div class="Home-bottom-bg1">
          <div class="Home-bottom-bg1-title1"> 立即致电商务顾问 </div>
          <div class="Home-bottom-bg1-relation-bg">
            <div class="Home-bottom-bg1-title2"> 拨打咨询电话，立即领取大礼包 </div>
            <img class="Home-bottom-bg1-portrait" :src=img.Portrait>
          </div>
          <div class="Home-bottom-bg1-relation-bg">
            <div class="Home-bottom-bg1-title3"> 0571-8690 8892 </div>
            <div class="Home-bottom-bg1-title4">（工作时间 9:00-19:00）</div>
            
          </div>
          <div class="Home-bottom-line"></div>
          <div class="Home-bottom-bg1-right">
            <div class="Home-bottom-bg1-right-title"> 欢 迎 扫 码 咨 询 </div>
            <div class="Home-bottom-bg1-right-QRCode"></div>
            <div style="display: initial;margin-left: 10px;">
              <div><el-button class="Home-bottom-bg1-right-button1" type="primary" @click="loginRegister"> 申请试用 </el-button></div>
              <div><el-button @click="onBottomClick({isShowQRCode: true})" class="Home-bottom-bg1-right-button2" type="primary" plain> 在线客服 </el-button></div>
            </div>
          </div>
          <div class="Home-bottom-bg1-bottom">
            <div class="Home-bottom-bg1-bottom-block" v-for="(item, index) in Bottoms" :key="index">
              <el-link target="_blank" type="info" style="color:#fff;" @click="onBottomClick(item)"> {{item.Title}} </el-link>
              <div v-if="index!=0" class="Home-bottom-bg1-bottom-block-line"></div>
            </div>
          </div>
        </div>
        <div class="Home-bottom-bg2">
          <a target="_blank" href="https://beian.miit.gov.cn/" style="color:#fff;">浙ICP备18039694号-3</a>
          <!-- <img src="@/assets/img/home/cn.png" style="margin: 4px 0px 0px 0px;" /> -->
          <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010802009909" style="color:#fff;margin-left:10px">浙公网安备 33010802009909号</a>
          杭州震旦科技有限公司2018-2019@All Rights Reserved
        </div>
      </div>
      <QRCodeAlert v-if="alertState.isShowQRCode"></QRCodeAlert>
      <div class="suspend">
        <template v-for="(item,index) in suspends">
            <div :key="index" @mouseover="suspendMouseover(index)" @mouseleave="suspendMouseleave(index)" @click="onSuspend(index)">
              <el-popover placement="left" trigger="hover">
                <QRCode></QRCode>
                <div class="suspend-div"  slot="reference" v-if="index===0 || index===3">
                  <el-image :src="index==suspendIdx?item.icons:item.icond" class="suspend-img"></el-image>
                  <div :style="{color:index==suspendIdx?'#7E49FE':'#666F80'}">{{item.title}}</div>
                </div>
              </el-popover>
              <div class="suspend-div" v-if="index!=0 && index!=3 && (index!=suspends.length-1 || isShowScrollTop)">
                <el-image :src="index===suspendIdx?item.icons:item.icond" class="suspend-img"></el-image>
                <div :style="{color:index===suspendIdx?'#7E49FE':'#666F80'}">{{item.title}}</div>
              </div>
            </div>
        </template>
      </div>
    </div>
</template>

<script>
import HomeProduct from '@/views/HomeProduct'
import HomeProject from '@/views/HomeProject'
import HomeCase from '@/views/HomeCase'
import QRCodeAlert from '@/views/QRCodeAlert'
import QRCode from '@/views/QRCode'
// ******************** image
import Banner1 from "@/assets/img/home/banner1.png"
import QRCodeImage from '@/assets/img/home/QRCode.png'

export default {
  components:{
    HomeProduct,
    HomeProject,
    HomeCase,
    QRCodeAlert,
    QRCode
  },
  data() {
    return {
      fit:"cover",
      banberHeight: 500,
      banberWidth: 1920,
      alertState: this.$store.state.alertState,
      suspendIdx:-1,
      isShowScrollTop: true,
      img: {
        Teams: require("../assets/img/home/team.png"),
        Portrait: require("../assets/img/home/service.png"),
        QRCode: QRCodeImage,
      },
      banners:[
        Banner1,
      ],
      suspends: [
        {
          title: "在线客服",
          icond: require("../assets/img/home/suspend_0_d.png"),
          icons: require("../assets/img/home/suspend_0_s.png"),
        },
        {
          title: "申请试用",
          icond: require("../assets/img/home/suspend_1_d.png"),
          icons: require("../assets/img/home/suspend_1_s.png"),
        },
        {
          title: "获取案例",
          icond: require("../assets/img/home/suspend_2_d.png"),
          icons: require("../assets/img/home/suspend_2_s.png"),
        },
        {
          title: "二维码",
          icond: require("../assets/img/home/suspend_3_d.png"),
          icons: require("../assets/img/home/suspend_3_s.png"),
        },
        {
          title: "返回顶部",
          icond: require("../assets/img/home/suspend_4_d.png"),
          icons: require("../assets/img/home/suspend_4_s.png"),
        },
      ],
      intros:[
        {
          Icon: require("../assets/img/home/icon1.png"),
          Title: "3000家",
          Subheading: "商家信赖之选"
        },
        {
          Icon: require("../assets/img/home/icon2.png"),
          Title: "5千万",
          Subheading: "累计服务用户数"
        },
        {
          Icon: require("../assets/img/home/icon3.png"),
          Title: "10+款",
          Subheading: "爆款工具"
        },
        {
          Icon: require("../assets/img/home/icon4.png"),
          Title: "5个",
          Subheading: "触达渠道"
        },
        {
          Icon: require("../assets/img/home/icon5.png"),
          Title: "7x12小时",
          Subheading: "服务响应速度"
        },
      ],
      HuoKes:[
        {
          Title: "获客引流",
          Id: 1,
          Icons: [
            {
              Icon: require("../assets/img/home/huoke_icon1.png"),
              Title: "内容互动",
            },
            {
              Icon: require("../assets/img/home/huoke_icon2.png"),
              Title: "裂变拓客",
            },
            {
              Icon: require("../assets/img/home/huoke_icon3.png"),
              Title: "新品投票",
            },
            {
              Icon: require("../assets/img/home/huoke_icon4.png"),
              Title: "动态活码",
            },
          ],
        },
        {
          Title: "高效沟通",
          Id: 2,
          Icons: [
            {
              Icon: require("../assets/img/home/huoke_icon5.png"),
              Title: "企业微信",
            },
            {
              Icon: require("../assets/img/home/huoke_icon6.png"),
              Title: "小程序客服",
            },
            {
              Icon: require("../assets/img/home/huoke_icon7.png"),
              Title: "公众号客服",
            },
            {
              Icon: require("../assets/img/home/huoke_icon8.png"),
              Title: "电话客服",
            },
          ],
        },
        {
          Title: "智能营销",
          Id: 3,
          Icons: [
            {
              Icon: require("../assets/img/home/huoke_icon9.png"),
              Title: "微信群发",
            },
            {
              Icon: require("../assets/img/home/huoke_icon10.png"),
              Title: "短信群发",
            },
            {
              Icon: require("../assets/img/home/huoke_icon11.png"),
              Title: "朋友圈",
            },
            {
              Icon: require("../assets/img/home/huoke_icon12.png"),
              Title: "群聊",
            },
          ],
        },
        {
          Title: "行业集成",
          Id: 4,
          Icons: [
            {
              Icon: require("../assets/img/home/huoke_icon13.png"),
              Title: "珠宝",
            },
            {
              Icon: require("../assets/img/home/huoke_icon14.png"),
              Title: "电商",
            },
            {
              Icon: require("../assets/img/home/huoke_icon15.png"),
              Title: "新零售",
            },
            {
              Icon: require("../assets/img/home/huoke_icon16.png"),
              Title: "M2B",
            },
          ],
        },
      ],
      Bottoms: [
        {
          Title: "震旦官网",
          Href: this.$store.state.zdUrl,
        },
        {
          Title: "宝物志",
          Href: this.$store.state.bwzUrl+"/",
        },
        {
          Title: "宝来屋",
          Href: this.$store.state.blwUrl+"/",
        },
        {
          Title: "关于我们",
          Href: this.$store.state.zdUrl+"/aboutus",
        },
        {
          Title: "服务条款",
          Href: this.$store.state.blkUrl+"/loginRegister",
        },
        {
          Title: "在线客服",
          isShowQRCode: true,
        },
        {
          Title: "意见反馈",
          Href: this.$store.state.blkUrl+"/loginRegister",
        }
      ],
    }
  },
  mounted(){
    let self = this
    
    this.banberHeight = this.getBanberHeight();
    this.banberWidth = this.getBanberWidth();
    window.onresize = function(){
      self.banberHeight = self.getBanberHeight();
      self.banberWidth = self.getBanberWidth();
    }
    window.addEventListener('scroll', this.onScroll);
  },
  methods:{
    onSuspend(index) {
      if(index === 1) {
        window.open(this.$store.state.blkUrl+"/loginRegister");
      }else if(index === 2) {
        this.gotoElementById("a5");
      }else if(index === 4) {
        document.documentElement.scrollTop = 0;
      }
      this.suspendIdx = -1
    },
    gotoElementById(index) {
      let id = index.split("-");
      var anchor = this.$el.querySelector("#"+id[0])
      document.documentElement.scrollTop = anchor.offsetTop - 60;
    },
    onScroll() {
      let scrollTop = document.documentElement.scrollTop;
      this.isShowScrollTop = scrollTop > 500;
    },
    // 鼠标移入
    suspendMouseover(index){
      this.suspendIdx = index
    },
    // 鼠标移出
    suspendMouseleave(index){
      this.suspendIdx = -1
    },
    onHuoKeDetails(id) {
      this.onBaoLaiKem();
    },
    loginRegister() {
      window.open(this.$store.state.blkUrl+"/loginRegister");
    },
    onBaoLaiKem() {
      window.open(this.$store.state.blkUrl+"/loginRegister");
    },
    getBanberHeight() {
      if (document.documentElement.clientWidth < 1400) return 500 * 1400 / 1920;
      if (document.documentElement.clientWidth > 1920) return 500;
      return document.documentElement.clientWidth * 500 / 1920;
    },
    getBanberWidth() {
      if (document.documentElement.clientWidth < 1400) return 1400;
      if (document.documentElement.clientWidth > 1920) return 1920;
      return document.documentElement.clientWidth;
    },
    onBottomClick(item) {
      if (item.Href) {
        window.open(item.Href);
      }else if(item.Index) {
        var anchor = this.$el.querySelector("#"+item.Index)
        document.documentElement.scrollTop = anchor.offsetTop - 60;
      }else if(item.isShowQRCode) {
        this.alertState.isShowQRCode = true;
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.Home{
    padding:0;
    background: $back-color;
    min-width: 1500px;
    &-one {
      color:#fff;
      min-width: 1400px;
      max-width: 1920px;
      margin: 0 auto;
      &-banber {
        min-width: 1400px;
        max-width: 1920px;
        margin: 0 auto;
      }
    }
    &-two{
      &-bg{
        width: 1400px;
        height:240px;
        margin: 0 auto;
        margin-top: -30px;
        z-index:10;
        position: relative;
      }
      &-item{
        text-align: center;
        margin-left: 41px;
        margin-top: 30px;
        // width: 280px;
        &-icon{
          width: 100px;
          height: 100px;
        }
        &-title{
          font-size: 24px;
          color: #211C39;
        }
        &-subheading{
          font-size: 14px;
          color: #666F80;
        }
      }
    }
    &-huoke{
      text-align: center;
      margin: 0 auto;
      width: 1500px;
      &-title{
        margin-top: 100px;
        font-size: 36px;
        color: #211C39;
        font-weight: bold;
      }
      &-subheading{
        font-size: 20px;
        margin-top: 20px;
        color: #514D66;
      }
      &-item-bg{
        height: 611px;
        margin: 0 auto;
        margin-top: 60px;
        margin-left: 40px;
        &-item{
          height: 511px;
          width: 320px;
          border: 1px solid #EDEFFA;
          border-radius: 6px;
          &-title{
            color: #fff;
            text-align: left;
            font-size: 24px;
            margin: -60px 0px 0px 30px;
          }
          &-title-bg{
            width: 320px;
            height: 80px;
          }
          &-icon{
            width: 70px;
            height: 70px;
            margin-top: 60px;
          }
          &-title1{
            font-size: 18px;
            color: #514D66;
          }
          &-bottom{
            width: 320px;
            height: 100px;
            background: #F4F4F9;
            bottom: 99px;
            position: absolute;
            border-radius: 0px 0px 4px 4px;
            &-button{
              border-color: #7E49FE;
              margin-top: 28px;
            }
          }
        }
      }
    }
    &-advertising {
      width: 100%;
      height: 530px;
      margin: 0 auto;
      &-bg {
        width: 1400px;
        height: 440px;
        background: #F8F9FF;
        border-radius: 6px;
        margin: 0 auto;
        margin-top: 100px;
        &-title {
          font-size: 34px;
          font-weight: 800;
          color: #3E35C5;
          line-height: 34px;
          text-align: center;
          padding-top: 60px;
        }
        &-subheading {
          background: #F8F9FF;
          border-radius: 6px;
          text-align: center;
          padding-top: 20px;
        }
        &-content {
          display: flex;
          margin: 42px 29px 0px 40px;
          justify-content: space-between;
        }
        &-left {
          width: 600px;
          &-title {
            font-size: 22px;
            font-weight: 800;
            color: #211C39;
            line-height: 22px;
          }
          &-subheading {
            font-size: 16px;
            font-weight: 400;
            color: #514D66;
            line-height: 16px;
            margin: 20px 0px 60px 0px;
          }
          &-button {
            width: 140px;
            height: 50px;
            border-radius: 27px;
            border: 1px solid #7E49FE;
            font-size: 18px;
            font-weight: 400;
            color: #514D66;
            line-height: 18px;
          }
        }
        &-right {
          width: 488px;
          height: 234px;
        }
      }
    }
    &-bottom {
      width: 100%;
      height: 304px;
      margin: 0 auto;
      background: linear-gradient(135deg, #599AF7 0%, #8142FF 100%);
      &-bg1 {
        width: 1400px;
        height: 274px;
        margin: 0 auto;
        &-title1 {
          font-size: 24px;
          font-weight: 800;
          color: #FFFFFF;
          line-height: 24px;
          padding-top: 60px;
          padding-bottom: 20px;
        }
        &-title2 {
          font-size: 18px;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 18px;
          padding-bottom: 32px;
          padding-right: 27px;
        }
        &-relation-bg {
          display: flex;
          width: 500px;
        }
        &-title3 {
          font-size: 24px;
          font-weight: 800;
          color: #FFFFFF;
          line-height: 24px;
        }
        &-title4 {
          font-size: 14px;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 14px;
          margin-top: 5px;
        }
        &-portrait {
          width: 70px;
          height: 70px;
          border-radius: 35px;
          margin-top: -50px;
        }
        &-right {
          display: flex;
          width: 300px;
          height: 170px;
          float: right;
          margin-top: -90px;
          &-title {
            width: 18px;
            font-size: 16px;
            font-weight: 800;
            color: #FFFFFF;
            line-height: 20px;
            letter-spacing: 1px;
            padding-right: 10px;
          }
          &-QRCode {
            width: 118px;
            height: 118px;
            background: #FFFFFF;
            border-radius: 4px;
            background-image: url("../assets/img/home/QRCode.png");
            background-repeat: round;
          }
          &-button1 {
            width: 140px;
            height: 50px;
            background: #FFFFFF;
            box-shadow: 0px 10px 10px -3px rgba(126, 73, 254, 0.3);
            border-radius: 4px;
            font-size: 18px;
            font-weight: 400;
            color: #7F47FE;
            line-height: 18px;
          }
          &-button2 {
            width: 140px;
            height: 50px;
            border-radius: 4px;
            border: 1px solid #FFFFFF;
            font-size: 18px;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 18px;
            margin-top: 16px;
          }
        }
        &-bottom {
          width: 1600px;
          height: 30px;
          display: flex;
          &-block {
            width: 222px;
            color: ivory;
            &-line {
              background-color: #918DFB;
              width: 1px;
              height: 10px;
              margin-left: -80px;
              margin-top: -15px;
            }
          }
        }
      }
      &-line {
        width: 1px;
        height: 80px;
        background-color: #918DFB;
        margin: 0 auto;
        margin-top: -100px;
      }
      &-bg2 {
        width: 100%;
        height: 30px;
        background-color: #7242E6;
        text-align: center;
        font-size: 12px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 30px;
      }
    }
    
  }
  .suspend{
    position: fixed;
    z-index: 199;
    margin:auto;
    right: 20px;
    top:0;
    bottom:0;
    height: 378px;
    div:nth-child(5){
      margin-top: 28px
    }
    &-div {
      width:60px;
      height:70px;
      border: 1px solid #EFF0F7;
      background: #fff;
      font-size: 12px;
      display: flex;
      margin-top: -1px;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      :nth-child(1){
        width:32px;
        height:32px
      }
    }
  }
</style>
<style>
  .el-carousel__indicators--horizontal {
    bottom: 25px !important;
  }
</style>